if (!customElements.get('product-badges')) {
  class ProductBadges extends HTMLElement {
    constructor() {
      super();

      this.currentBadges = badgesArray;
      this.tagsArray = this.dataset.tags.split('||');

      this.initBadges();

    }

    initBadges() {  
      var labels = [];

      if (this.tagsArray.length && this.currentBadges.length) {
        this.tagsArray.forEach(tag => {
          this.currentBadges.forEach(function (badge) {
            if (tag === badge.tag) {
              var badgeElement = document.createElement('span');
              var badgeClass = badge.text?.toLowerCase().replace(/ /g,'-');
              badgeElement.classList.add('badges__item', 'product__badge', `badge--${badgeClass}`);
              badgeElement.style.color = badge.color;
              badgeElement.style.backgroundColor = badge.bg_color;
              badgeElement.textContent = badge.text;
              badgeElement.style.borderColor = badge.outline_color;

              var badgeHandle = badgeElement.textContent.toLowerCase()

              if (!badgeHandle.includes('customize')) {
                labels.push(badgeElement);
              };
            }
          });
        });

        if (labels.length) {
          labels.forEach(label => {
            this.appendChild(label);
          });
        }
      }
    }
  }
  
  customElements.define('product-badges', ProductBadges);
}
  